<template>
  <div>
    <gSwiper :arr="arr" :maxH="'inherit'"></gSwiper>
    <div class="register">
      <Row :gutter="10" class="top">
        <Col span="24">
        <div class="title">广州国际分析测试及实验室设备展览会暨技术研讨会  展商报名
        <p>CHINA LAB Exhibitor registration</p></div>
        </Col>
        <!-- <Col span="8" class="f-tar">
        <Button shape="circle" style="margin-left:10px" @click="$router.push(`/ex-register-en/register-mobile`)">English</Button>
        </Col> -->
      </Row>
      <registerForm ref="registerForm"></registerForm>
      <registerAddr ref="registerAddr"></registerAddr>

     

      <div class="tip-info" style="margin-top: -20px;">
        <p>注：</p>
        <p>1.二、三类及升级展区，转角展位加RMB 530元/个</p>
        <p>2.标准展位规格为3mX3m，光地仅限特装企业，光地起租面积为18平方米起，且为9的倍数</p>
        <p>3.展位价格含税，开具增值税专用发票</p>
        <p>4.展商可凭发票向当地税局申请全额抵扣6%的增值税费</p>
        <p>Notes</p>
        <p>1. An additional RMB 530 will be charged for any Type II, Type III or upgraded area booth located at the corner</p>
        <p>2. The standard booth size is 3m x 3m, and the raw space can only be booked by companies requiring a special booth design,The minimum rental area for bare land is 18 square meters, which is a multiple of 9.</p>
        <p>3. The booth price includes tax, as will be specified in a VAT invoice</p>
        <p>4. Exhibitors can use the invoice to apply for a deduction of 6% VAT at local tax authorities</p>
      </div>
    </div>
    <div class="f-tac submit-btn">
        <Button type="primary" size="large" @click="handleSubmit" :loading="loading">确定以上信息，并提交展位申请
        <p>Determine the above information and </p>
        <p>submit the booth application </p>
        </Button>
      </div>
  </div>
</template> 

<script> 
import gSwiper from "@components/gSwiper/gSwiper2.vue";
import { mapActions } from "vuex";
import registerForm from "./components/mobile-register-form.vue";
import registerAddr from "./components/mobile-register-addr.vue";
export default {
  name: 'register',
  components: {
    registerForm,
    registerAddr,
    gSwiper,
  },
  props: {},
  data () {
    return {
      loading: false,
      arr: [{ id: 1, path: 'https://synairsoft.obs.cn-north-4.myhuaweicloud.com/cloudExhibition/imgs/202305/0487d913201443df9a3249896e09ae01.jpg' }],
    };
  },
  watch: {},
  computed: {},
  methods: {
    ...mapActions({
      getApplyCompanyRoastCreate: 'registerdModule/getApplyCompanyRoastCreate', // 新增展会接口
    }),
    async handleSubmit () {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let res = await this.$refs.registerForm.handleSubmit();
      this.loading = false;
      if (!res.valid) return;
      let res2 = await this.$refs.registerAddr.validHandle();
      this.loading = false;
      if (!res2.valid) return;
      console.log('registerForm', res);
      console.log('registerAddr', res2);
      let opt = {
        newCompany: { ...res.form },
        lists: [{
          exhibitionId: 'f1b6d862-44e4-4b3b-afc8-5495749e84e2',
          ...res2.ApplyCompanyOrder
        }],
        reportType: 'cn'
      };
      let exname = '';
      res2.exhibition.forEach((c, index) => {
        exname += (c.nameEn || 'FIBO CHINA 2022');
        if (res2.exhibition.length !== index + 1) {
          exname += ','
        }
      });
      console.log('option', opt);
      let bool = await this.getApplyCompanyRoastCreate(opt);
      this.loading = false;
      console.log('getApplyCompanyRoastCreate', bool);
      if (bool && bool.successed) {
        let query = 'company=' + encodeURI(res.form.companyName) + '&exname=' + encodeURI(exname);
        this.$router.push(`/ex-register/register-result?${query}`);
      } else {
        let errTxt = bool.msg || bool.info || "提交失败，请重新尝试！";
        if (bool.errors && bool.errors[0] && bool.errors[0].description) {
          errTxt = bool.errors[0].description;
        }
        this.$Message.error(errTxt);
      }
    },
    IsPC () {
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone",
        "iPad", "iPod"];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    }
  },
  created () {
    if (this.IsPC()) {
      this.$router.push(`/ex-register/register`);
    }
  },
  mounted () { }
}

</script>

<style lang="scss" scoped>
.register {
  max-width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  .top {
    padding: 15px;
  }
  .title {
    font-size: 13px;
    color: #00a0e9;
    font-weight: bold;
    // line-height: 32px;
  }
}
.submit-btn {
  margin-top: -30px;
  text-align: center;
  button {
    padding: 0 46px;
    background-color: #00a0e9;
    font-size: 16px;
    border-color: #00a0e9;
    margin-bottom: 30px;
    height: 80px;
    border-radius: 20px;
    font-size: 15px;
    color: #fff;
  }
}
.tip-info {
  margin: 0 auto 48px;
  padding: 15px;
  white-space: nowrap;
  p {
    font-size: 12px;
    color: #333;
    margin-bottom: 4px;
    white-space: normal;
  }
}
</style>
